"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SL = void 0;
exports.SL = {
    numericCode: '694',
    alpha2Code: 'SL',
    alpha3Code: 'SLE',
    englishName: {
        short: 'Sierra Leone',
        full: 'the Republic of Sierra Leone',
    },
    names: {
        full: {
            en: 'the Republic of Sierra Leone',
            fr: 'la République de Sierra Leone',
        },
        short: {
            en: 'Sierra Leone',
            fr: 'Sierra Leone (la)',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
    ],
    subdivisions: {
        'SL-W': {
            numericCode: '694',
            code: 'SL-W',
            category: {
                id: '359',
                names: {
                    en: {
                        singular: 'area',
                        plural: 'areas',
                    },
                    fr: {
                        singular: 'zone',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Western Area (Freetown)',
            },
        },
        'SL-E': {
            numericCode: '694',
            code: 'SL-E',
            category: {
                id: '424',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Eastern',
            },
        },
        'SL-N': {
            numericCode: '694',
            code: 'SL-N',
            category: {
                id: '424',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Northern',
            },
        },
        'SL-NW': {
            numericCode: '694',
            code: 'SL-NW',
            category: {
                id: '424',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'North Western',
            },
        },
        'SL-S': {
            numericCode: '694',
            code: 'SL-S',
            category: {
                id: '424',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Southern',
            },
        },
    },
    cities: [
        {
            name: 'Waterloo',
            subdivision: 'Western Area',
        },
        {
            name: 'Segbwema',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Port Loko',
            subdivision: 'Northern Province',
        },
        {
            name: 'Makeni',
            subdivision: 'Northern Province',
        },
        {
            name: 'Lunsar',
            subdivision: 'Northern Province',
        },
        {
            name: 'Koidu',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Kenema',
            subdivision: 'Eastern Province',
        },
        {
            name: 'Kabala',
            subdivision: 'Northern Province',
        },
        {
            name: 'Freetown',
            subdivision: 'Western Area',
        },
        {
            name: 'Bo',
            subdivision: 'Southern Province',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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